import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bfb6b5c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4bfb6b5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb6b5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bfb6b5c')) {
      api.createRecord('4bfb6b5c', component.options)
    } else {
      api.reload('4bfb6b5c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4bfb6b5c&scoped=true", function () {
      api.rerender('4bfb6b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v-dialog/index.vue"
export default component.exports